import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  width: 100%;

  @media (max-width: 1224px) {
    padding: 1rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.75rem;

  h1 {
    margin-left: 1rem;
    font-family: 'RedHatDisplay-ExtraBold';
    font-size: 2.2rem;
    color: #1e88e5;
  }

  span {
    margin-left: 0.5rem;
    font-size: 1rem;
    color: #323232;
  }

  .header-comunity {
    display: flex;
    align-items: center;
  }

  .primary-button {
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 1.6rem;
    }

    span {
      font-size: 0.85rem;
    }
  }

  @media (max-width: 580px) {
    flex-direction: column;
    align-items: flex-start;

    .header-comunity {
      flex-direction: column;
      align-items: flex-start;
    }

    h1 {
      font-size: 1.4rem;
    }

    .primary-button {
      align-self: stretch;
      text-align: center;
    }
  }
`;

export const TitlePanel = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  gap: 1.5rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 1rem;
  }
`;

export const UserProjectSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  min-width: 0;

  @media (max-width: 1024px) {
    flex-direction: row;
    width: 100%;
  }
`;

export const UserProjectHighlighted = styled.div`
  width: 100%;

  > p {
    padding: 0.5rem 1rem;
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }

  &.hidden {
    opacity: 0;
    transform: translateY(20px);
  }

  &.fade-in {
    animation: ${fadeIn} 0.8s ease-out forwards;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const PostProject = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  border-radius: 1rem;

  /* video entra junto: post sem imagem usa o primeiro quadro do vídeo
     como capa — ver PostThumbnail. */
  > img,
  > video {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 1rem;
  }

  cursor: pointer;
  overflow: visible;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-5px);
  }

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 20rem;
    > img,
    > video {
      width: 100%;
      height: auto;
      flex-shrink: 0;
    }
  }

  @media (max-width: 580px) {
    max-width: 100%;
  }
`;

export const LikesandComents = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0 0 1rem 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));

  div {
    display: flex;
    align-items: center;
    gap: 0.33rem;

    span {
      font-size: 1rem;
      color: #ffffff;
    }
  }
`;

export const EmptyPostProject = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  text-align: center;

  > img {
    width: 90%;
  }

  .primary-button {
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;

    svg {
      margin-right: 0.5rem;
    }
  }

  p {
    font-size: 1rem;
    color: #323232;
    margin-top: 0.5rem;
  }

  &.hidden {
    opacity: 0;
    transform: translateY(20px);
  }

  &.fade-in {
    animation: ${fadeIn} 0.8s ease-out forwards;
  }
`;

export const TimelineSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 1px solid #e0e0e0;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  flex: 1;
  min-width: 0;

  > h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1rem;
    text-align: center;
  }

  @media (max-width: 1024px) {
    border-left: 0px;
    border-top: 1px solid #e0e0e0;
    margin-top: 1rem;
    margin-left: 0;
    padding: 1rem 0 0 0;
    width: 100%;
  }
`;

export const Timeline = styled.div`
  width: 100%;
  display: flex;
  margin-top: 1.44rem;
  flex-direction: column;
`;

export const ProjectItem = styled.div`
  display: flex;
  margin-bottom: 1.44rem;
  border-radius: 0.5rem;
  gap: 0.75rem;

  img,
  video {
    border-radius: 0.5rem;
    width: 8rem;
    height: 6rem;
    aspect-ratio: 4/3;
    object-fit: cover;
    object-position: center;
    flex-shrink: 0;
    /* Fundo próprio: o quadro do vídeo raramente preenche 4/3 exato. */
    background: #000;
  }

  cursor: pointer;
  overflow: visible;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-5px);
  }

  &.hidden {
    opacity: 0;
    transform: translateY(20px);
  }

  &.fade-in {
    animation: ${fadeIn} 0.6s ease-out forwards;
  }

  &.delay-0 {
    animation-delay: 0.3s;
  }

  &.delay-1 {
    animation-delay: 0.6s;
  }

  &.delay-2 {
    animation-delay: 0.9s;
  }

  @media (max-width: 580px) {
    flex-direction: column;

    img {
      width: 100%;
      height: auto;
      aspect-ratio: 16/9;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
  min-width: 0;
  flex: 1;

  h3 {
    font-family: 'RedHatDisplay-Bold';
    color: #1e88e5;
    font-size: 1rem;
    margin-top: 0.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }

  p {
    font-size: 0.81rem;
    color: #323232;
    margin-top: 0.3rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }

  @media (max-width: 580px) {
    margin-left: 0;
    margin-top: 0.5rem;
  }
`;

export const SocialSection = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  gap: 0.8rem;
  margin-bottom: 0.5rem;

  > div {
    display: flex;
    align-items: center;
    gap: 0.33rem;
  }
`;

export const EmptyTimeline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem 1rem;
  gap: 0.8rem;

  > svg {
    opacity: 0.6;
  }

  > p {
    font-size: 1rem;
    color: #757575;
    margin-top: 0.3rem;
  }

  .primary-button {
    margin-top: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-size: 0.9rem;

    svg {
      margin-right: 0.5rem;
    }
  }

  &.hidden {
    opacity: 0;
    transform: translateY(20px);
  }

  &.fade-in {
    animation: ${fadeIn} 0.8s ease-out forwards;
    animation-delay: 0.3s;
  }

  @media (max-width: 580px) {
    padding: 1.5rem 0.75rem;

    > p {
      font-size: 0.9rem;
    }
  }
`;
